import { generateApiClient } from '@guiker/rest-client'

import { PublicApi } from '../api-definition'
import { config } from '../config'

export const PublicApiClient = generateApiClient(config.apiName, PublicApi.routes)
